import { lazy } from 'react';



const PaymentCheckoutConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/payment-checkout',
      component: lazy(() => import('./PaymentCheckout')),
    },
  ],
};

export default PaymentCheckoutConfig

